<!--理财-->
<template>
    <div class="id">
        <div class="head">
            <div>
                <span>{{ $t('当前团队等级') }}</span>
                <span style="padding: 0 10px;color: #f7931a;">V{{ teamLevel }}</span>
            </div>
            <span style="color: #00f0ff" @click="$router.push(`/mobile/grade`)">{{ $t('等级规则') }}</span>
        </div>
        <div class="box">
            <van-image width="30" height="30" src="https://shengge975.com/img/118.d1642339.png" />
            <div>{{ totalProfit }}USDT {{ $t('策略总收益') }}</div>
        </div>
        <div class="vanSwipe">
            <van-image width="20" height="20" :src="require('@/assets/img/footer/icon6.svg')" :radius="200" />
            <van-swipe vertical :autoplay="3000" class="vertical-swipe">
                <van-swipe-item v-for="(item, index) in userIds" :key="index">{{ item }}</van-swipe-item>
            </van-swipe>
        </div>

        <div class="currency">
            <div class="currencyTop">
                <div class="itemTop" style="border-right: 1px dashed #2d2d2e;">
                    <div>{{ $t('使用人数') }}</div>
                    <div>{{ count }}</div>
                </div>
                <div class="itemTop">
                    <div>{{ $t('累计赚取') }}</div>
                    <div>{{ totalProfit }}</div>
                </div>
            </div>
            <div class="currencyBot">
                <div class="itemBot" v-for="item in productList" :key="item.id">
                    <div class="Amount">
                        <van-image height="18" width="18" :src="item.image" />
                        <div style="padding-left: 6px;">{{ item.symbol }}</div>
                    </div>
                    <div class="AmountS">{{ item.price }}</div>
                </div>
            </div>
        </div>
        <div class="cmBtn" @click="$router.push('/mobile/aiOrder')">
            <div style="padding-right: 20px;">{{ $t('策略订单') }}</div>
            <van-image width="16" height="16" :src="require('@/assets/img/footer/icon8.svg')" />
        </div>

        <div class="title">{{ $t('策略广场') }}</div>

        <div class="contentS" v-for="item in aiProduct" :key="item.id">
            <div class="contentT">
                <div class="boxW">
                    <van-image v-for="value in item.product_list" :key="value.id" width="30" :src="value.image"
                        class="img" />
                    <div>{{ item.invest }}</div>
                </div>
                <div style="color: #888;">
                    {{ item.type }}{{ $t('预测') }}
                </div>
            </div>
            <van-image width="100%" height="56" :src="item.image_bg" />
            <div class="contentBox">
                <div class="itemQ" style="border-right: 1px dashed #2d2d2e;">
                    <div class="boxS">
                        <div>{{ $t('最大收益率') }}</div>
                        <div style="color: #00f0f0;">{{ item.rate }}%</div>
                    </div>
                    <div class="boxS" style="padding-top: 8px;">
                        <div>{{ $t('投入金额') }}</div>
                        <div>>{{ item.amount }}</div>
                    </div>
                </div>
                <div class="itemQ">
                    <div class="boxS">
                        <div>{{ $t('最大回撤率') }}</div>
                        <div style="color: #00f0f0;">{{ item.ratemax }}%</div>
                    </div>
                    <div class="boxS" style="padding-top: 8px;">
                        <div>{{ $t('运行时常') }}</div>
                        <div>{{ item.days }}d</div>
                    </div>
                </div>
            </div>
            <div class="btn">
                <div>
                    {{ item.name }}
                </div>
                <div @click="useCk(item)">{{ $t('使用本策略') }}</div>
            </div>
        </div>

        <van-popup v-model="showPopup" position="bottom" round :style="{ height: '72%' }" >
            <div class="popupId">
                <div class="combination">
                    <div class="contentT">
                        <div class="boxW">
                            <van-image v-for="value in popupItem.product_list" :key="value.id" width="30"
                                :src="value.image" class="img" />
                            <div>{{ popupItem.invest }}</div>
                        </div>
                        <div style="color: #888;">
                            {{ popupItem.type }}{{ $t('预测') }}
                        </div>
                    </div>

                    <div class="contentW">
                        <div class="itemT">
                            <div>{{ $t('使用人数') }}</div>
                            <div>{{ popupItem.purchased_number }}</div>
                        </div>
                        <div class="itemT">
                            <div>{{ $t('跟随资金') }}</div>
                            <div>{{ popupItem.follow_money }}</div>
                        </div>
                    </div>
                    <div class="contentBot">
                        <div class="itemT" v-for="(v, i) in popupItem.exercise_price" :key="i">
                            <div>{{ v.title }}</div>
                            <div>{{ v.profit }}</div>
                        </div>
                    </div>
                </div>
                <div class="universal">
                    <div class="itemT">
                        <div>{{ $t('运行时长') }}</div>
                        <div>{{ popupItem.days }}d</div>
                    </div>
                    <div class="itemT">
                        <div>{{ $t('区间最低价') }}</div>
                        <div>{{ popupItem.amax }}</div>
                    </div>
                    <div class="itemT">
                        <div>{{ $t('最大收益率') }}</div>
                        <div>{{ popupItem.rate }}%</div>
                    </div>
                    <div class="itemT">
                        <div>{{ $t('网格收益率') }}</div>
                        <div>{{ popupItem.netrate }}%</div>
                    </div>
                    <div class="itemT">
                        <div>{{ $t('最大回撤率') }}</div>
                        <div>{{ popupItem.ratemax }}%</div>
                    </div>
                    <div class="itemT">
                        <div>{{ $t('最大服务费') }}</div>
                        <div>{{ popupItem.commission }}</div>
                    </div>
                </div>
                <div class="interval">
                    <van-field v-model="amountS" :label="$t('投资金额')" :placeholder="$t('输入金额')" label-width="100px"
                        input-align="right" label-align="left" />
                    <div style="padding-top: 10px;">
                        {{ $t('当前余额') }} {{ earnAccount }}
                    </div>
                </div>

                <div class="btnS" @click="aiSubmit(popupItem.id)">{{ $t('使用本策略') }} </div>
            </div>
        </van-popup>


    </div>
</template>
<script>
import { get, post } from '@/http/request'
import apis from '@/http/api';

export default {
    components: {
    },
    data() {
        return {
            showPopup: false,
            amountS: '',
            userIds: [],
            totalProfit: '',
            count: '',
            productList: [],
            aiProduct: [],
            teamLevel: '',
            popupItem: {},
            earnAccount: "",
            active: 0,
            source: [
                {
                    name: this.$t('进行中')
                },
                {
                    name: this.$t('已结束')
                }
            ],
        };
    },
    mounted() {
        this.aiData()
        this.getUserInfo()
    },
    beforeUnmount() { },
    methods: {
        async aiData() {
            const res = await get(apis.aiData)
            if (res.code == 1) {
                this.userIds = res.data.user_ids
                this.totalProfit = res.data.total_profit
                this.count = res.data.count
                this.productList = res.data.product_list
                this.aiProduct = res.data.all_ai_product
                this.teamLevel = res.data.team_level
                return
            }
        },
        async useCk(id) {
            const res = await get(apis.aiInfo, { id: id.id })
            if (res.code == 1) {
                this.popupItem = res.data
                this.showPopup = true
                return
            }
        },
        async getUserInfo() {
            const res = await get(apis.getUserInfo)
            if (res.code == 1) {
                this.earnAccount = res.data.earn_account
                return
            }
        },

        async aiSubmit(id) {
            const res = await post(apis.aiSubmit, { id: id, amount: this.amountS, })
            if (res.code == 1) {
                this.amountS = ''
                this.showPopup = false
                this.$toast(res.msg);
                setTimeout(() => {
                    this.getUserInfo()
                }, 1000);
                return
            }
        },

      

    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
}

.boxBtn {
    padding: 10px;
    background-color: #12141e;
    border-radius: 10px;

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #20212c;
    }

    .accountS {
        padding: 0 10px;
        overflow-y: auto;
        height: 60vh;
        scrollbar-width: none;
        /* Firefox */
        -ms-overflow-style: none;

        .boxT {
            border-bottom: 1px solid #252733;
            padding: 10px 0;
        }

        .contentQ {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 10px;

            .boxBtn {
                background-color: #1a1b24;
                color: #fff;
                font-size: 12px;
                padding: 6px 12px;
                border-radius: 20px;
            }

            .boxW {
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .img:nth-child(2) {
                    position: relative;
                    left: -10px;
                }

                .boxWq {
                    color: #00f0ff;
                    background-color: #000;
                    margin-left: 15px;
                    padding: 6px 12px;
                    border-radius: 15px;
                    font-size: 12px;
                }
            }
        }

        .boxQ {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;

            div:nth-child(1) {
                color: #5e5e7a;
            }
        }


    }
}

.popupId {
    background-color: #12141e;
    height: 72vh;
    padding: 20px;

    .interval {
        margin: 15px 0;

        ::v-deep .van-cell::after {
            border-bottom: 0px solid #000;
        }

        ::v-deep .van-cell {
            background-color: #0b0b0d;
        }

        ::v-deep .van-cell {
            color: #fff;
            height: 50px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            border-radius: 5px;
        }

        ::v-deep .van-field__label {
            color: #888;
        }

    }

    .btnS {
        background-color: #00f0ff;
        text-align: center;
        color: #000;
        padding: 10px;
        border-radius: 10px;
        margin: 20px 0;
    }

    .universal {
        padding: 20px;
        padding-bottom: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        border-radius: 5px;
        background-color: #0b0b0d;
        flex-wrap: wrap;

        .itemT {
            width: 44%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;

            div:nth-child(1) {
                color: #888;
            }
        }
    }

    .combination {
        margin-top: 10px;
        background-color: #0b0b0d;
        border-radius: 10px;
        padding: 20px;

        .contentT {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 20px;

            .boxW {
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .img:nth-child(2) {
                    position: relative;
                    left: -10px;
                }
            }
        }

        .contentW {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .itemT {
                text-align: center;

                div:nth-child(1) {
                    color: #888;
                }

                div:nth-child(2) {
                    font-size: 18px;
                    padding-top: 8px;
                }
            }
        }

        .contentBot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 20px;

            .itemT {
                text-align: center;

                div:nth-child(1) {
                    color: #888;
                    font-size: 12px;
                }

                div:nth-child(2) {
                    font-size: 18px;
                    padding-top: 8px;
                    color: #00f0ff;
                }
            }
        }
    }

}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 20px;
    padding-top: 50px;
    font-size: 14px;

    .head {
        padding: 15px 0;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .box {
        height: 50px;
        justify-content: center;
        border-radius: 8px;
        border: 1px solid #1a1b24;
        background: #12141e;
        color: #888;
        padding: 0 20px;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
    }

    .vanSwipe {
        display: flex;
        align-items: center;

        .vertical-swipe {
            height: 40px;
            line-height: 40px;
            color: #fff;
            padding-left: 10px;

        }

        ::v-deep .van-swipe__indicators {
            display: none;
        }
    }

    .currency {
        background-color: #0b0b0d;
        border-radius: 10px;
        border: 1px solid #252731;
        margin: 10px 0;

        .currencyTop {
            padding: 20px;
            display: flex;
            justify-content: space-around;
            border-bottom: 1px dashed #2d2d2e;

            .itemTop {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #888;
                width: 50%;

                div:nth-child(2) {
                    font-size: 24px;
                    color: #fff;
                    padding-top: 4px;
                }

            }
        }

        .currencyBot {
            padding: 20px 10px;
            display: flex;
            justify-content: space-around;
            border-bottom: 1px dashed #2d2d2e;

            .itemBot {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #888;
                width: 33%;

                .Amount {
                    display: flex;
                    font-size: 14px;
                    align-items: center;
                }

                .AmountS {
                    font-size: 14px;
                    color: #fff;
                    padding-top: 6px;
                }
            }
        }

    }

    .title {
        padding-top: 20px;
        font-size: 22px;
    }

    .cmBtn {
        margin: 20px auto;
        width: 70vw;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #333;
        background-color: #000;
        color: #fff;
        border-radius: 40px;
        overflow: hidden;
        padding: 10px 0;
    }

    .contentS {
        background-color: #0b0b0d;
        border-radius: 10px;
        margin: 20px 0;
        padding: 15px;

        .contentT {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .boxW {
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .img:nth-child(2) {
                    position: relative;
                    left: -10px;
                }
            }
        }

        .contentBox {
            display: flex;
            font-size: 11px;

            .itemQ {
                width: 50%;
                padding: 10px;

                .boxS {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    div:nth-child(1) {
                        color: #888;
                    }
                }
            }

        }

        .btn {
            padding-top: 20px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: space-between;

            div:nth-child(1) {
                color: #f7931a;
            }

            div:nth-child(2) {
                background-color: #00f0ff;
                color: #000;
                padding: 8px 20px;
                border-radius: 30px;
            }
        }
    }

}
</style>
